module.exports = __webpack_public_path__ + "img/4.1.09ffc3f3.jpg";